/* Curated family looks and an optional, once-per-page offer after a successful add. */
(() => {
  const eligible = (rules, handle, variantId, age) => {
    const rule=rules?.[handle]?.[age];
    return rule===true || (Array.isArray(rule) && rule.some(id=>String(id)===String(variantId)));
  };
  const filterMatches=(groups, filter)=>groups.split(/\s+/).includes(filter);
  if(typeof module!=='undefined' && module.exports){module.exports={eligible,filterMatches};return;}
  if(window.martliFamilyHubLoaded)return;
  window.martliFamilyHubLoaded=true;
  let sequence=0;
  function dialogFor(host){
    const dialog=host.querySelector('dialog');
    if(!dialog || typeof dialog.showModal!=='function')return null;
    let opener;
    const close=()=>dialog.close();
    dialog.querySelectorAll('[data-dialog-close]').forEach(b=>b.addEventListener('click',close));
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom)close();}});
    dialog.addEventListener('close',()=>{
      document.body.classList.remove('mfh-dialog-open');
      if(opener?.isConnected)opener.focus({preventScroll:true});
    });
    return {
      open(entries,title,trigger){
        const fragment=host.querySelector('[data-look-form]').content.cloneNode(true);
        const family=fragment.querySelector('martli-family');
        family.id='FamilyLook-'+(++sequence);family.dataset.entries=JSON.stringify(entries);
        dialog.querySelector('[data-look-container]').replaceChildren(fragment);
        if(title)dialog.querySelector('[data-dialog-title]').textContent=title;
        opener=trigger || document.activeElement;
        dialog.dataset.count=String(entries.length);
        dialog.showModal();document.body.classList.add('mfh-dialog-open');
        dialog.querySelector('[data-dialog-close]').focus({preventScroll:true});
      }
    };
  }
  document.querySelectorAll('[data-family-hub]').forEach(hub=>{
    hub.querySelectorAll('[data-look-gallery]').forEach(gallery=>{
      const track=gallery.querySelector('[data-gallery-track]');
      const total=track.children.length;
      if(total<=2)return;
      const prev=gallery.querySelector('[data-gallery-prev]');
      const next=gallery.querySelector('[data-gallery-next]');
      const counter=gallery.querySelector('[data-gallery-count]');
      gallery.dataset.enhanced='true';prev.hidden=false;next.hidden=false;
      const updateGallery=()=>{
        if(!track.clientWidth)return;
        const step=track.children[0].getBoundingClientRect().width+4;
        const first=Math.max(0,Math.min(total-2,Math.round(track.scrollLeft/step)));
        counter.textContent=`${first+1}–${Math.min(total,first+2)} / ${total}`;
        prev.disabled=track.scrollLeft<2;
        next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;
      };
      const move=direction=>track.scrollBy({left:direction*(track.clientWidth+4),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',updateGallery,{passive:true});
      if(window.ResizeObserver)new ResizeObserver(updateGallery).observe(track);
      updateGallery();
    });
    const cards=[...hub.querySelectorAll('[data-look-card]')];
    const count=hub.querySelector('[data-look-count]');
    const update=filter=>{
      let n=0;cards.forEach(card=>{card.hidden=!filterMatches(card.dataset.groups,filter);if(!card.hidden){
        n++;
        const track=card.querySelector('[data-gallery-track]');
        if(track){
          const slides=[...track.children];
          const target=filter==='siblings'?slides.findIndex(s=>['boy','girl'].includes(s.dataset.galleryRole)):['mum','dad'].includes(filter)?slides.findIndex(s=>s.dataset.galleryRole===filter):0;
          const index=Math.max(0,Math.min(slides.length-2,target));
          const width=slides[0]?.getBoundingClientRect().width || 0;
          track.scrollTo({left:index*(width+4),behavior:'instant'});
        }
      }});
      hub.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===filter)));
      count.textContent=count.dataset.label+' '+n;
    };
    hub.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>update(b.dataset.filter)));
    update('all');
    const controller=dialogFor(hub);
    hub.querySelectorAll('[data-open-look]').forEach(b=>{
      if(!controller){b.hidden=true;return;}
      b.addEventListener('click',()=>controller.open(JSON.parse(b.closest('[data-look-card]').querySelector('[data-look-items]').textContent),b.dataset.lookTitle,b));
    });
  });
  const offerHost=document.querySelector('[data-family-offer]');
  const source=document.querySelector('martli-family[data-handle]');
  if(!offerHost || !source)return;
  const controller=dialogFor(offerHost);
  if(!controller)return;
  let rules,shown=false;
  fetch(offerHost.dataset.rules).then(r=>{if(!r.ok)throw new Error('rules');return r.json();}).then(data=>{rules=data.rules;}).catch(()=>{});
  document.addEventListener('martli:cart-added',event=>{
    const p=source.source,data=source.data,core=window.MartliFamilyCore;
    if(shown || !rules || !p || !data || !core)return;
    const v=p.variants.find(v=>String(v.id)===String(event.detail.variantId));
    if(!v)return;
    const adult=eligible(rules,p.handle,v.id,'adult');
    const child=eligible(rules,p.handle,v.id,'child');
    if(!adult && !child)return;
    const targetAge=adult?'child':'adult';
    const lists=core.recommendations(data,p.handle,v.options,adult).filter(list=>list.some(r=>{
      const isChild=['girl','boy','child'].includes(r.role);
      return (targetAge==='child')===isChild && rules[r.handle]?.[targetAge];
    }));
    if(!lists.length)return;
    // Intercept only when the reviewed catalogue contains a potentially eligible counterpart.
    event.preventDefault();shown=true;
    const trigger=document.activeElement;
    (async()=>{
      const cartResponse=await fetch((window.Shopify?.routes?.root || '/')+'cart.js',{headers:{'Accept':'application/json'},cache:'no-store'});
      if(!cartResponse.ok)throw new Error('cart');
      const cart=await cartResponse.json();
      const alreadyQualifies=['adult','child'].every(age=>cart.items.some(item=>eligible(rules,item.handle,item.variant_id,age)));
      if(alreadyQualifies){window.location.assign((window.Shopify?.routes?.root || '/')+'cart');return;}
      const matches=await Promise.all(lists.map(async list=>{
        for(const rec of list){
          try{
            const product=await source.product(rec.handle);
            const ok=core.variantsFor(product,rec.role).some(variant=>variant.available && eligible(rules,product.handle,variant.id,targetAge) && Object.entries(rec.preset||{}).every(([i,value])=>variant.options[Number(i)]===value));
            if(ok)return {...rec,hideReason:true};
          }catch(_){/* Try the next reviewed match. */}
        }
      }));
      const entries=matches.filter(Boolean);
      if(!entries.length){window.location.assign((window.Shopify?.routes?.root || '/')+'cart');return;}
      // The original garment was already added; only additional garments appear in this form.
      offerHost.querySelector('[data-added]').textContent=adult?offerHost.dataset.adultAdded:offerHost.dataset.childAdded;
      controller.open(entries,null,trigger);
      const html=event.detail.response?.sections?.['cart-icon-bubble'];
      if(html){
        const parsed=new DOMParser().parseFromString(html,'text/html');
        const target=document.getElementById('cart-icon-bubble');
        const content=parsed.querySelector('.shopify-section');
        if(target && content)target.innerHTML=content.innerHTML;
      }
    })().catch(()=>window.location.assign((window.Shopify?.routes?.root || '/')+'cart'));
  });
})();
